// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root___yc8h","header":"Messages_header__2c47s"};